import { mediaQueries, palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

export const RliAddress = styled.span`
  font-size: 1rem;
  line-height: 1.5;
  grid-column: 1 / span 2;
  color: ${palette.brand.darkGray};

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          font-weight: 400;
        `
      default:
        return css`
          font-weight: 500;
        `
    }
  }}
`

export const RliTitle = styled.span<{ gridRow?: string }>`
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  text-overflow: ellipsis;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  font-size: 1.125rem;
  margin-bottom: 0.25rem;
  color: ${palette.brand.darkGreen};
  ${props => (props.gridRow ? `grid-row: ${props.gridRow};` : '')}
  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          fontWeight: 500,
          maxWidth: '30rem',
        }
      default:
        return {
          fontWeight: 700,
          maxWidth: '15rem',
        }
    }
  }}
`

export const RliDistance = styled.span`
  letter-spacing: 0.0375rem;
  text-align: right;
  grid-column: 2;
  grid-row: 1;
  color: ${palette.brand.gray};
  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          fontWeight: 400,
          fontSize: '0.875rem',
        }
      default:
        return {
          fontWeight: 800,
          fontSize: '0.75rem',
        }
    }
  }}
`
export const RliTaxonomy = styled.span`
  font-size: 0.875rem;
  grid-row: 2;
  color: rgb(89, 97, 110);
  font-weight: 600;
  margin-bottom: 0.7rem;
  grid-column: 1 / span 2;
`

export const RliContainer = styled.div<{
  usePointerCursor?: boolean
  isOpen?: boolean
}>`
  display: grid;
  border: 1px solid ${palette.brand.darkGreen};
  background-color: transparent;
  text-align: left;
  grid-template-columns: 1fr fit-content;

  &:nth-child(2) {
    margin-top: 0;
  }

  &:not(:first-child) {
    margin-bottom: 1.25rem;
  }
  border-radius: 20px;

  ${props => props.usePointerCursor && 'cursor: pointer;'}
  ${({ theme, usePointerCursor, isOpen }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          border-color: ${isOpen
            ? palette.brand.orange
            : palette.brand.darkGreen};
          padding: 1rem 1.25rem;

          &:hover {
            ${() => {
              if (!usePointerCursor) {
                return `border-color: ${palette.brand.orange}`
              }

              return !isOpen && `background-color: #F7F4E6;`
            }}
          }
        `
      default:
        return css`
          background-color: transparent;
          padding: 1rem;
        `
    }
  }}

  &:first-of-type {
    margin-top: 0;
  }

  .container__display {
    display: flex;

    > p:not(:last-child),
    > div:not(:last-child) {
      margin-right: 1.5rem;
    }

    @media ${({ theme }) => theme.mediaQueries.mobile} {
      flex-direction: column;
    }

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return css`
            span,
            p {
              color: #212121;
              font-weight: 400;
            }
          `
        default:
          return {}
      }
    }}
  }

  > svg {
    margin-left: 0.5rem;
  }

  > ${RliAddress}, > ${RliTaxonomy}, .container__display {
    grid-column: span 2;
  }

  @media ${mediaQueries.mobile} {
    margin: 0;
  }
`
